export default __webpack_public_path__ + "static/media/fitogram.4819cfef.svg";